module.exports = __webpack_public_path__ + "img/foot_logo.438c38c7.svg";